module.exports = __webpack_public_path__ + "img/hzch.ef04bf51.png";